import styled from '@emotion/styled'

export const Header = styled.span`
  font-family: Satoshi;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0%;
  line-height: 24px;
  margin-bottom: 1rem;
  margin-top: 1rem;
`
